module.exports = __webpack_public_path__ + "static/media/Iran_Europe.3a250202.svg";